module.exports = __webpack_public_path__ + "fundo-inicio.jpg?1004cf9c3f3cf27813617faec645aeac";


//////////////////
// WEBPACK FOOTER
// ./assets/images/fundo-inicio.jpg
// module id = 879
// module chunks = 0